import React, { useState, useEffect } from "react";
import {
    buscarPessoasAutorizadasPorUsuario,
    excluirVisitanteAgendado,
} from "../../../api/requisicoes/pessoas";
import { formatarDataBrasilia } from "../../../utils/functions";
import IconExcluir from "../../../assets/icone-excluir.png";

import useInterceptarVoltar from "../../../components/InterceptarVolta";

import { useConfirm } from "../../../context/ConfirmContext";
import { useAlert } from "../../../context/AlertContext";

import Loading from "../../../components/Loading";
import iconeVoltar from "../../../assets/icone-voltar.webp";
import iconeRefresh from "../../../assets/refresh.webp";
import "./style.css";

const obterDataAtual = () => {
    const dataAgora = new Date();
    const dataAgoraUTC =
        dataAgora.getTime() + dataAgora.getTimezoneOffset() * 60000;
    const dataAgoraMinasGerais = new Date(dataAgoraUTC - 3 * 3600000);
    const ano = dataAgoraMinasGerais.getFullYear();
    const mes = String(dataAgoraMinasGerais.getMonth() + 1).padStart(2, "0");
    const dia = String(dataAgoraMinasGerais.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
};

const VisitantesAgendadosMobile = ({ setActiveComponent }) => {
    const [loading, setLoading] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [visitantes, setVisitantes] = useState([]);
    const [visitantesFiltrados, setVisitantesFiltrados] = useState([]);
    const [expandedCardId, setExpandedCardId] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [focusedInput, setFocusedInput] = useState(null);

    useInterceptarVoltar("agendamento", setActiveComponent);

    const [animando, setAnimando] = useState(false);

    const aguardarAnimacao = () => {
        return new Promise((resolve) => setTimeout(resolve, 200));
    };

    const fetchPessoasAutorizadas = async () => {
        setLoading(true);
        try {
            const userId = localStorage.getItem("userId");
            if (userId) {
                const dados = await buscarPessoasAutorizadasPorUsuario(userId);
                const dataHoje = obterDataAtual();
                const visitantesFiltrados = dados
                    .filter((item) => item.dataVisita >= dataHoje)
                    .sort(
                        (a, b) =>
                            new Date(a.dataVisita) - new Date(b.dataVisita)
                    );

                setVisitantes(dados);
                setVisitantesFiltrados(visitantesFiltrados);
            } else {
                console.log("Nenhum usuário encontrado no localStorage.");
            }
        } catch (error) {
            console.error("Erro ao buscar visitantes autorizados:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPessoasAutorizadas();
    }, []);

    const { showConfirm } = useConfirm(); // Use o hook useConfirm
    const { showAlert } = useAlert();

    const onRefresh = async () => {
        const img = document.querySelector(
            ".visitantesAgendadosMobile-refreshButton img"
        );

        if (img) {
            img.classList.add("girar-uma-vez");

            // Remove a classe depois da animação (2s)
            setTimeout(() => {
                img.classList.remove("girar-uma-vez");
            }, 1000);
        }

        setRefreshing(true);
        await fetchPessoasAutorizadas();
        setRefreshing(false);
    };

    const navegarParaAgendamento = async () => {
        await aguardarAnimacao();
        setActiveComponent("agendamento");
    };

    const handleCardPress = (id) => {
        setExpandedCardId(expandedCardId === id ? null : id);
    };

    const handleExcluir = async (item) => {
        await aguardarAnimacao();

        showConfirm(
            `Deseja realmente excluir ${item.nomeCompleto} da agenda?`,
            async () => {
                try {
                    setCarregando(true);
                    await excluirVisitanteAgendado(item.id);
                    const novaLista = visitantes.filter(
                        (v) => v.id !== item.id
                    );
                    setVisitantes(novaLista);
                    setVisitantesFiltrados(
                        novaLista.filter(
                            (v) => new Date(v.dataVisita) >= new Date()
                        )
                    );
                    showAlert(
                        `O visitante ${item.nomeCompleto} foi excluído da agenda.`,
                        "sucesso"
                    );
                } catch (error) {
                    console.error("Erro ao excluir visitante:", error);
                    showAlert(
                        "Houve um problema ao tentar excluir o visitante.",
                        "erro"
                    );
                } finally {
                    setCarregando(false);
                }
            },
            () => {} // callback do "cancelar"
        );
    };

    const handleSearch = (query) => {
        setSearchQuery(query);
        if (query === "") {
            setVisitantesFiltrados(
                visitantes.filter(
                    (item) => new Date(item.dataVisita) >= new Date()
                )
            );
        } else {
            const filteredData = visitantes.filter(
                (item) =>
                    (item.nomeCompleto
                        .toLowerCase()
                        .includes(query.toLowerCase()) ||
                        item.empresa
                            .toLowerCase()
                            .includes(query.toLowerCase()) ||
                        item.responsavel
                            .toLowerCase()
                            .includes(query.toLowerCase())) &&
                    new Date(item.dataVisita) >= new Date()
            );
            setVisitantesFiltrados(filteredData);
        }
    };

    return (
        <div className="visitantesAgendadosMobile-tela">
            {carregando && <Loading />}
            <div className="visitantesAgendadosMobile-header">
                <div
                    className="visitantesAgendadosMobile-voltar"
                    onClick={() => {
                        navegarParaAgendamento();
                    }}
                >
                    <img
                        src={iconeVoltar}
                        alt="Voltar"
                        className="visitantesAgendadosMobile-voltar-icon"
                    />
                </div>
                <div className="visitantesAgendadosMobile-titulo">
                    <h1>Visitantes Agendados</h1>
                </div>
            </div>
            <div className="visitantesAgendadosMobile-container">
                <div className="visitantesAgendadosMobile-pesquisar">
                    <div className="visitantesAgendadosMobile-inputBusca">
                        <input
                            type="text"
                            className={`searchInput ${
                                focusedInput === "search" ? "inputFocused" : ""
                            }`}
                            placeholder="Pesquisar..."
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </div>
                    <div
                        onClick={onRefresh}
                        className="visitantesAgendadosMobile-refreshButton"
                    >
                        <img src={iconeRefresh} alt="Atualizar" />
                    </div>
                </div>
                <div className="visitantesAgendadosMobile-lista">
                    {loading ? (
                        <></>
                    ) : visitantesFiltrados.length === 0 ? (
                        <p>Nenhum visitante encontrado.</p>
                    ) : (
                        visitantesFiltrados.map((item) => (
                            <div
                                className="visitantesAgendadosMobile-card"
                                key={item.id}
                            >
                                <div
                                    className="visitantesAgendadosMobile-cardHeader"
                                    onClick={() => handleCardPress(item.id)}
                                >
                                    <h3 className="visitantesAgendadosMobile-cardTitle">
                                        {item.nomeCompleto}
                                    </h3>
                                    <p className="visitantesAgendadosMobile-cardSubtitle">
                                        {formatarDataBrasilia(
                                            item.dataVisita,
                                            true
                                        )}
                                    </p>
                                </div>
                                {expandedCardId === item.id && (
                                    <div className="visitantesAgendadosMobile-cardDetails">
                                        <div className="visitantesAgendadosMobile-cardInformacoes">
                                            <p>
                                                <strong>Empresa:</strong>{" "}
                                                {item.empresa}
                                            </p>
                                            <p>
                                                <strong>Responsável:</strong>{" "}
                                                {item.responsavel}
                                            </p>
                                            <p>
                                                <strong>Horário:</strong>{" "}
                                                {item.horarioVisita}
                                            </p>
                                        </div>
                                        <div
                                            onClick={() => handleExcluir(item)}
                                            className="visitantesAgendadosMobile-botaoExcluir"
                                        >
                                            <img
                                                src={IconExcluir}
                                                alt="Excluir"
                                                className="iconeExcluir"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>

        // <div className="container">
        //     <input
        //         type="text"
        //         className={`searchInput ${
        //             focusedInput === "search" ? "inputFocused" : ""
        //         }`}
        //         placeholder="Buscar por nome, empresa ou responsável"
        //         value={searchQuery}
        //         onFocus={() => setFocusedInput("search")}
        //         onBlur={() => setFocusedInput(null)}
        //         onChange={(e) => handleSearch(e.target.value)}
        //     />

        //     <button
        //         onClick={onRefresh}
        //         disabled={refreshing}
        //         className="refreshButton"
        //     >
        //         {refreshing ? "Atualizando..." : "Atualizar"}
        //     </button>

        //     {loading ? (
        //         <p>Carregando...</p>
        //     ) : visitantesFiltrados.length === 0 ? (
        //         <p>Nenhum visitante encontrado.</p>
        //     ) : (
        //         visitantesFiltrados.map((item) => (
        //             <div className="card" key={item.id}>
        //                 <div
        //                     className="cardHeader"
        //                     onClick={() => handleCardPress(item.id)}
        //                 >
        //                     <h3 className="cardTitle">{item.nomeCompleto}</h3>
        //                     <p className="cardSubtitle">
        //                         {formatarDataBrasilia(item.dataVisita)}
        //                     </p>
        //                 </div>
        //                 {expandedCardId === item.id && (
        //                     <div className="cardDetails">
        //                         <p>
        //                             <strong>Empresa:</strong> {item.empresa}
        //                         </p>
        //                         <p>
        //                             <strong>Responsável:</strong>{" "}
        //                             {item.responsavel}
        //                         </p>
        //                         <p>
        //                             <strong>Horário:</strong>{" "}
        //                             {item.horarioVisita}
        //                         </p>
        //                         <button
        //                             onClick={() => handleExcluir(item)}
        //                             className="iconButton"
        //                         >
        //                             <img
        //                                 src={IconExcluir}
        //                                 alt="Excluir"
        //                                 className="iconImage"
        //                             />
        //                         </button>
        //                     </div>
        //                 )}
        //             </div>
        //         ))
        //     )}
        // </div>
    );
};

export default VisitantesAgendadosMobile;
